import React, { useState } from 'react';
import { useAuth } from './AuthProvider';
import './LoginCard.css';

const LoginCard = () => {
    const { login, isLoading } = useAuth();
    const [loginError, setLoginError] = useState(null);

    const handleLogin = async () => {
        try {
            setLoginError(null);
            await login();
        } catch (error) {
            console.error('Login error:', error);
            setLoginError('Failed to sign in. Please try again.');
        }
    };

    return (
        <div className="login-card">
            <div className="login-card-content">
                <div className="login-icon">
                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 4V6C15 7.66 13.66 9 12 9S9 7.66 9 6V4L3 7V9L9 12V18C9 19.1 9.9 20 11 20H13C14.1 20 15 19.1 15 18V12L21 9Z" fill="#c22630"/>
                    </svg>
                </div>
                
                <h2 className="login-title">Welcome to Snack Lookup</h2>
                <p className="login-subtitle">Sign in with your Microsoft account to view your snack bar spending</p>
                
                {loginError && (
                    <div className="login-error">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="#dc3545"/>
                        </svg>
                        <span>{loginError}</span>
                    </div>
                )}
                
                <button 
                    className="login-button"
                    onClick={handleLogin}
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <>
                            <div className="login-spinner"></div>
                            <span>Signing in...</span>
                        </>
                    ) : (
                        <>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M23 11.99C23 5.37 17.6 0 11 0S0 5.37 0 11.99C0 18.61 5.4 24 12 24C18.6 24 23 18.61 23 11.99Z" fill="#00BCF2"/>
                                <path d="M12 3C16.97 3 21 7.03 21 12C21 16.97 16.97 21 12 21C7.03 21 3 16.97 3 12C3 7.03 7.03 3 12 3Z" fill="white"/>
                                <path d="M12 6C9.24 6 7 8.24 7 11S9.24 16 12 16 17 13.76 17 11 14.76 6 12 6ZM12 14C10.34 14 9 12.66 9 11S10.34 8 12 8 15 9.34 15 11 13.66 14 12 14Z" fill="#00BCF2"/>
                            </svg>
                            <span>Sign in with Microsoft</span>
                        </>
                    )}
                </button>
                
                <div className="login-features">
                    <div className="feature-item">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 12L11 14L15 10M21 12C21 16.97 16.97 21 12 21S3 16.97 3 12 7.03 3 12 3 21 7.03 21 12Z" stroke="#28a745" strokeWidth="2" fill="none"/>
                        </svg>
                        <span>Secure authentication</span>
                    </div>
                    <div className="feature-item">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="#ffc107" strokeWidth="2" fill="none"/>
                        </svg>
                        <span>Real-time spending data</span>
                    </div>
                    <div className="feature-item">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 19C-2 19 2 3 2 3S6 1 12 5C18 1 22 3 22 3S26 19 15 19L12 16L9 19Z" stroke="#17a2b8" strokeWidth="2" fill="none"/>
                        </svg>
                        <span>Privacy protected</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginCard;